import { render } from "./CollectionCard.vue?vue&type=template&id=72242fd4"
import script from "./CollectionCard.vue?vue&type=script&lang=js"
export * from "./CollectionCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/luvenan/projects/reading-nook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__